import { HttpErrorResponse } from '@angular/common/http';
import { ApiError } from '@core/errors/api-error';

export class UnauthenticatedApiError extends ApiError {
  constructor(cause: HttpErrorResponse, body: unknown) {
    super('UnauthenticatedApiError', cause, body);
  }
}
